module.exports = __webpack_public_path__ + "img/presentation-chart_sofr-092326.3370524f.png";